// Utilitário para formatação de datas UTC para o fuso do Brasil
export function formatDateToBR(dateString?: string) {
  if (!dateString) return '-';
  // Pega só a parte da data (YYYY-MM-DD), mesmo se vier com T
  const data = dateString.split('T')[0];
  const [ano, mes, dia] = data.split('-');
  if (ano && mes && dia) {
    return `${dia}/${mes}/${ano}`;
  }
  return dateString;
} 